import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Modal } from "./Modal"
import AppStore from "../../stores/appStore"

const ModalNotification = ({ isShow, className }) => {
  const [element, setElement] = useState(<h1></h1>)
  const [title, setTitle] = useState("")

  useEffect(() => {
    //console.log("BODY: ", AppStore.bodyNotificationModal().element())
    setElement(AppStore.bodyNotificationModal().element())
    setTitle(AppStore.bodyNotificationModal().title)
  }, [AppStore.bodyNotificationModal])


  return (
    <div>
      <Modal
        isModal={false}
        isShow={AppStore._isVisibleNotificationModal}
        onClose={() => AppStore.hideNotificationModal()}
        title={title}
        className={className}
      >
        {element}
      </Modal>
    </div>
  )
}

ModalNotification.propTypes = {}

export default ModalNotification
